<template>
    <div class="mmp-zoom-container" title="Zoom Level">{{ roundedZoomLevel }}</div>
</template>
<style src="./../Data_Tools/Data_Tools.css" scoped></style>
  
<style>
.mmp-zoom-container {
    width: 40px;
    height: 40px;
    background-color:#063c6d;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 2px;
    flex-direction: row; 
    border-radius: 5.5px;
    border: 2px #063c6d solid;
    color: white;
    font-size: medium !important;
}
</style>

<script>
export default {
    name: 'DT_Zoom',
    props: [
        'map'
    ],
    computed: {
        roundedZoomLevel() {
            if (this.map) {
                return Math.round(this.map.getView().getZoom())
            } else {
                return undefined
            }
        }
    }
}
</script>